import '../styles/footer.css'

export function Footer({imprintUrl}) {
    return (<>
        <footer>
            {imprintUrl != undefined ? <a className="whiteLink" href={`${imprintUrl || ''}`} target="_blank">Impressum</a> : null }
            <div className="powered">
                <span style={{marginRight: '10px'}}>Powered by</span> 
                <a href="http://www.sam-performance.com" target="_blank">
                    <img className='image' src="https://app.sam-performance.com/images/logo_dark_back.png"  alt='' />
                </a>
            </div>
        </footer>
    </>)
}